export const Urls = {
    RefreshRelativePath: "token/refresh",
    Register: "token/register",
    Login: "token/login",
    LoginWithThirdPartyProvider: "token/LoginWithThirdPartyProvider",   
    Logout: "token/logout",
    ReloadUser: "token/reloadUser",
    ValidateTwoFactAuthCode: "token/ValidateTwoFactAuthCode",
    ResendCode: "token/SendNewTwoFactAuthCode",
    ChangePassword: "token/changePassword",
    GetPasswordPolicy: "token/getPasswordPolicy",
};
